/* eslint-disable react/no-unused-state */
import { createContext, Component, ReactNode } from 'react';

type fn = () => void;
type Props = {
  children: ReactNode;
};
type State = {
  hasSidebar: boolean;
  renderSidebar: fn;
  onRenderSidebar: (renderSidebar: fn) => fn;
};

export const SidebarContext = createContext<State>({
  hasSidebar: false,
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  renderSidebar() {},
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onRenderSidebar() {
    return () => {};
  },
});

const renderCallbacks: fn[] = [];

// eslint-disable-next-line import/no-default-export
export default class SidebarProvider extends Component<Props, State> {
  state = {
    hasSidebar: false,
    renderSidebar: () => {
      renderCallbacks.forEach(cb => cb());
    },
    onRenderSidebar: (renderSidebar: fn) => {
      renderCallbacks.push(renderSidebar);
      this.setState({
        hasSidebar: true,
      });

      return () => {
        const idx = renderCallbacks.indexOf(renderSidebar);
        renderCallbacks.splice(idx, 1);
        this.setState({ hasSidebar: renderCallbacks.length > 0 });
      };
    },
  };

  render() {
    return (
      <SidebarContext.Provider value={this.state}>
        {this.props.children}
      </SidebarContext.Provider>
    );
  }
}
